import { render, staticRenderFns } from "./my-tickets.vue?vue&type=template&id=5d4facfe&scoped=true&"
import script from "./my-tickets.vue?vue&type=script&lang=js&"
export * from "./my-tickets.vue?vue&type=script&lang=js&"
import style0 from "./my-tickets.vue?vue&type=style&index=0&id=5d4facfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4facfe",
  null
  
)

export default component.exports